export function formatNumber(value, decimals) {
    const formattedValue = Number(value).toFixed(decimals);
    const dotIndex = formattedValue.indexOf('.');
    const decimalValue = formattedValue.substr(dotIndex + 1, formattedValue.length);

    if (decimalValue === '0'.repeat(decimals)) {
        return formattedValue.substr(0, dotIndex);
    }

    return formattedValue;
}

export function formatFileSize(valueToFormat) {
    const value = Number(valueToFormat);

    if (value === 0 || isNaN(value)) {
        return '0 MB';
    }

    const size = Math.floor(Math.log(value) / Math.log(1024));
    return (value / Math.pow(1024, size)).toFixed(2) * 1 + ' ' + ['bytes', 'kB', 'MB', 'GB', 'TB'][size];
}

export function formatDownloadSpeed(valueToFormat) {
    const value = Number(valueToFormat);

    if (value === 0 || isNaN(value)) {
        return '0 MB/s';
    }

    const size = Math.floor(Math.log(value) / Math.log(1024));
    return (value / Math.pow(1024, size)).toFixed(2) * 1 + ' ' + ['b/s', 'kB/s', 'MB/s', 'GB/s', 'TB/s'][size];
}

export function formatPercentage(valueToFormat) {
    return Number(valueToFormat).toFixed(0) + '%';
}
